import {MainRequest} from 'Services/common';
import {IsPageType, OperateType} from 'Stores/commonStore';

export interface GetOperateList extends PaginationAntD {
    actionName?: string; //操作名称
    catid: string;
}
export interface OperateList {
    catid: string; //    所属栏目id
    id: string; //    主键 为空新增 不为空修改
    actionName: string; //    操作名称
    isPage: IsPageType; //    是否是翻页动作 1不是2是
    pageType: OperateType; //    页面类型 1列表页 2 内容页
    actionTextValue: string; //    动作的元素的内容的值，用来判断的，比如点分页的a标签的值的内容是下一页
    actionValue: string; //    操作的值
    actionXpath: string; //    要操作的元素的xpath
    listorder: number; //    操作的次序
    actionEvent: string; //    操作的事件
}

export function getOperatePage(params?: GetOperateList) {
    return MainRequest.post<SuccessData<OperateList[]>>('/bigdata/getActions', {
        ...params,
        pageNo: params?.current,
        pageSize: params?.pageSize,
    })
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res,
                total: res?.length,
            };
        });
}

export interface OperateEntityItem extends Omit<OperateList, 'id'> {
    id?: string;
}
//编辑
export function editOperate(data: OperateEntityItem) {
    return MainRequest.post('/bigdata/saveAction', data);
}

//删除
export function deleteOperate(id: string) {
    return MainRequest.post(`/bigdata/deleteAction`, {
        id,
    });
}
